import { PROPERTY_TYPES } from "@/features/properties/services/properties";
import { ALL_FIELDS } from "./fields";

export function downloadTemplate() {
  const headers = ALL_FIELDS.map((field) => field.label);

  const instructionRow = [
    "INSTRUCTIONS: Property Type must be one of: " +
      PROPERTY_TYPES.join(", ") +
      ". Use decimal format for coordinates (e.g., 34.493015). Delete this row before importing.",
    "", "", "", "", "", "", "", "", "", "", "", "", "", "", "",
  ];

  const sampleProperties = [
    ["Site 20360", "1201 Bois D'Arc Ave", "Duncan", "OK", "73533", "USA", "34.493015", "-97.96416", "Commercial", "Retail Store", "", "", "", "", ""],
    ["Site 42519", "11225 Quaker Avenue", "Lubbock", "TX", "79424", "USA", "33.49123", "-101.90453", "Commercial", "Retail Store", "", "", "", "", ""],
    ["Site 42523", "6317 Milwaukee Avenue", "Lubbock", "TX", "79424", "USA", "33.535095", "-101.95651", "Commercial", "Retail Store", "", "", "", "", ""],
  ];

  const emptyRows = [
    ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
    ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
  ];

  const csvRows = [headers, instructionRow, ...sampleProperties, ...emptyRows];
  const csvContent = csvRows.map((row) => row.join(",")).join("\n");

  const blob = new Blob([csvContent], { type: "text/csv" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "property_import_template.csv";
  a.click();
  window.URL.revokeObjectURL(url);
}
